module.exports = __webpack_public_path__ + "img/unselect_icon.a55e95b3.svg";